import useBridge from './useBridge'
import CustomBridge from '../controllers/bridge/CustomBridge'
import useStateControls from './useStateControls'
import errorHandlerReducer from '../redux/reducer/errorHandlerReducer'
import { useDispatch } from 'react-redux'
import { useApplicationCallbacks } from '../providers/application-callbacks'
import { productsApi } from '../utils/api/productsApi'
import { reportAuthWindowShown } from '../api/content'
import { _storage } from '../api/user'
import i18n from '../translations'
import { getPlaidLanguageId } from '../translations/utils'
import { useContent } from '../redux/reducer/content'

export default function useCustomBridge() {
  const { setState } = useStateControls()
  const dispatch = useDispatch()
  const callbacks = useApplicationCallbacks()
  const { products } = useContent()

  useBridge(
    {
      user({ data }) {
        console.log('GA TMG [Auth] 1️⃣ Получено событие USER от родительского окна', data)

        if (!data?.data) {
          console.log('GA TMG [Auth] ❌ Нет data.data, выход')
          return
        }

        const { data: userData } = data
        console.log('GA TMG [Auth] 🔍 Проверка токена:', {
          hasToken: !!userData?.token,
          tokenValue: userData?.token,
          processingStatus: userData?.processingStatus,
        })

        if (window.gib) {
          const sessionID = userData?.sessionID ?? null
          const authStatus = userData?.token ? window.gib.IS_AUTHORIZED : window.gib.IS_GUEST

          window.gib.setIdentity(sessionID)
          window.gib.setSessionID(sessionID)
          window.gib.setAuthStatus(authStatus)
        }

        if (userData?.token === undefined) {
          console.log('GA TMG [Auth] ⚠️ Токен undefined, сохранение без токена')
          reportAuthWindowShown({
            hadToken: !!_storage.load()?.access_token,
            reason: 'guest_no_token',
          })
          callbacks?.savePersonData({ ...userData })
          setState(userData?.share ? 'share' : 'info')
          return
        }

        if (userData?.token === null && userData?.processingStatus !== 'Found') {
          console.log('GA TMG [Auth] ❌ Токен null, статус НЕ Found, ошибка 404')
          reportAuthWindowShown({
            hadToken: !!_storage.load()?.access_token,
            reason: 'token_null_not_found',
          })
          dispatch(errorHandlerReducer.actions.addError({ name: 'notFound', code: 404 }))
          return
        }

        if (userData?.token === null && userData?.processingStatus === 'Found') {
          console.log('GA TMG [Auth] ❌ Токен null, статус Found, ошибка 400')
          reportAuthWindowShown({
            hadToken: !!_storage.load()?.access_token,
            reason: 'token_null_found',
          })
          dispatch(errorHandlerReducer.actions.addError({ name: 'Found', code: 400 }))
          return
        }

        if (userData?.token) {
          console.log('GA TMG [Auth] 2️⃣ Токен получен, запуск авторизации', userData?.token)
          callbacks?.savePersonData({ ...userData, access_token: userData.token })
          callbacks?.auth()
        } else {
          console.log('GA TMG [Auth] ⚠️ Токен не прошел проверку, значение:', userData?.token)
        }
      },
      completedUser({ data }) {
        const { data: userData = {} } = data ?? {}
        if (userData) callbacks.setCompletedUserData(userData)
      },
      appInfo({ data }) {
        const { data: appInfoData = {} } = data ?? {}
        console.log('appInfoData', appInfoData)
        if (appInfoData) {
          callbacks.setAppInfoData(appInfoData)

          productsApi.addHeaders({
            ...appInfoData.plaidHeaders,
            'plaid-language-id': getPlaidLanguageId(i18n.language),
          })
        }
      },
      favoritesSuccess({ data }) {
        const { sku } = data?.data ?? {}

        if (!sku) {
          return
        }

        const productId = products?.buyProducts?.find((item) => item.sku === sku)?.id ?? null

        if (productId) {
          callbacks.productToFavorites(productId)
        }
      },
    },
    CustomBridge,
  )
}
